<template>
  <el-form ref="form" :inline="true" v-bind="$attrs" class="search-form area-container"
    :class="{'fixed2width':+level===2}">
    <el-form-item :label="labels[0]">
      <el-select v-model="form.province" :placeholder="`请选择${labels[0]}`" :filterable="true" clearable
        @change="provinceChange">
        <el-option v-for="item in provinces" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="labels[1]">
      <el-select v-model="form.city" :placeholder="`请选择${labels[1]}`" :filterable="true" clearable @change="cityChange">
        <el-option v-for="item in cities" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="labels[2]" v-if="+level>=3">
      <el-select v-model="form.county" :placeholder="`请选择${labels[2]}`" :filterable="true" clearable
        @change="countyChange">
        <el-option v-for="item in counties" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'yblArea',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    labels: {
      type: Array,
      default: () => ['省', '市', '区']
    },
    level: { // 显示级别 （是否显示 【区】）
      type: String | Number,
      default: () => 3
    },
    checked: { // 选择的值
      type: Array | String,
      default: () => []
    }
  },
  data () {
    return {
      form: {
        province: '',
        city: '',
        county: ''
      },
      provinces: [],
      cities: [],
      counties: []
    }
  },
  created () {
    this.getProvince().then(data => {
      this.provinces = data
      if (this.checked) {
        let items = Array.isArray(this.checked) ? this.checked : this.checked.split(',')
        this.form.province = items[0]
        this.form.city = items[1] || ''
        this.form.county = items[2] || ''
        this.getProvinceCity(items[0] || 'x').then(data => {
          this.cities = data
        })
        this.form.city && this.getCityDistrict(this.form.city).then(data => {
          this.counties = data
        })
      }
    })
  },
  methods: {
    getProvince () {
      return this.$store.dispatch('customerGetProvince').then(data => {
        return data.NatGeoInfoList
      })
    },
    getProvinceCity (val) {
      return this.$store.dispatch('customerGetProvinceCity', { id: val }).then(data => {
        return data.NatGeoInfoList
      })
    },
    getCityDistrict (val) {
      return this.$store.dispatch('customerGetCityDistrict', { id: val }).then(data => {
        return data.NatGeoInfoList
      })
    },
    provinceChange (val) {
      this.cities = []
      this.counties = []
      /* if (val) {
        this.getProvinceCity(val).then(data => {
          this.cities = data
        })
      } */
      this.form.city = ''
      this.form.county = ''
      let item = [val, '', '']
      this.$emit('change', item)
    },
    cityChange (val) {
      let item = [this.form.province, val, '']
      this.$emit('change', item)
      if (this.level < 3) {
        return
      }
      this.counties = []
      /* if (val) {
        this.getCityDistrict(val).then(data => {
          this.counties = data
        })
      } */
      this.form.county = ''
    },
    countyChange (val) {
      let item = [this.form.province, this.form.city, val]
      this.$emit('change', item)
    }
  },
  watch: {
    'checked': function (newVal, oldVal) {
      if (newVal) {
        let items = Array.isArray(newVal) ? newVal : newVal.split(',')
        const oldItems = Array.isArray(oldVal) ? oldVal : oldVal.split(',')
        this.form.province = items[0]
        this.form.city = items[1] || ''
        this.form.county = items[2] || ''
        items[0] && items[0] !== oldItems[0] && this.getProvinceCity(items[0]).then(data => {
          this.cities = data
        })
        this.form.city && items[1] !== oldItems[1] && +this.level === 3 && this.getCityDistrict(this.form.city).then(data => {
          this.counties = data
        })
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.county = ''
      }
    }
  }
}
</script>

<style lang="less">
.area-container {
  display: flex;
  &.fixed2width {
    max-width: 200px;
  }
  &.search-form {
    &.el-form {
      .el-form-item__label {
        line-height: 33px;
      }
      .el-input {
        min-width: auto;
        width: auto;
      }
      .el-form-item:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Area.vue